import React, { useState } from "react";
import { Link } from "react-router-dom";
import { HiArrowRight } from "react-icons/hi";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
const products = [
  {
    id: 1,
    name: "FullStack Development",
    alt:"FullStack Development with Brain Box Study",
    link: "/ItCourse/FullStack",
    description: "Learn to create both the front and back ends of websites and web apps.",
    image1:
      "https://img.freepik.com/free-photo/person-front-computer-working-html_23-2150040428.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrid",
    image2:
      "https://img.freepik.com/free-vector/programmers-concept-with-flat-design_23-2147846147.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrid",
  },
  {
    id: 2,
    name: "Web Designing ",
    alt:"Web Designing with Brain Box Study",
    link: "/ItCourse/WebDesgin",
    description: "Learn how to make websites that look great and work well on any device.",
    image1:
      "https://img.freepik.com/free-photo/medium-shot-man-working-desk_23-2149930933.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrid",
    image2:
      "https://img.freepik.com/free-photo/programming-background-collage_23-2149901791.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrid",
  },
  {
    id: 3,
    name: "UI/UX Designing",
    alt:"UI/UX Designing with Brain Box Study",
    link: "/ItCourse/UiUx",
    description: "Learn to design websites and apps that are simple and enjoyable to use.",
    image1:
      "https://img.freepik.com/free-photo/representations-user-experience-interface-design_23-2150038917.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrid",
    image2:
      "https://img.freepik.com/free-vector/gradient-ui-ux-background_23-2149051557.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrid",
  },
  {
    id: 4,
    name: " Digital Marketing",
    alt:"Digital Marketing with Brain Box Study",
    link: "/ItCourse/DigitalMarketing",
    description: "Learn SEO, social media, and other tools to help businesses grow online.",
    image1:
      "https://img.freepik.com/free-photo/social-media-marketing-concept-marketing-with-applications_23-2150063134.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrid",
    image2:
      "https://img.freepik.com/free-photo/hand-holding-smartphone-social-media-concept_23-2150208245.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrid",
  },
  {
    id: 5,
    name: "Data Science",
    alt:"Data Science with Brain Box Study",
    link: "/ItCourse/DataScience",
    description: "Learn how to study data, find patterns, and solve problems with it.",
    image1:
      "https://img.freepik.com/free-photo/representation-user-experience-interface-design_23-2150169850.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrid",
    image2:
      "https://img.freepik.com/free-photo/representation-user-experience-interface-design_23-2150169834.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrid",
  },
  {
    id: 6,
    name: "Machine Learning",
    alt:"Machine Learning with Brain Box Study",
    link: "/ItCourse/MachineLearning",
    description: "Learn to build smart systems that can make predictions and decisions.",
    image1:
      "https://img.freepik.com/free-photo/3d-rendering-biorobots-concept_23-2149524396.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrid",
    image2:
      "https://img.freepik.com/free-photo/robot-hand-finger-ai-background-technology-graphics_53876-129793.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrid",
  },
  {
    id: 7,
    name: "Deep Learning",
    alt:"Deep Learning with Brain Box Study",
    link: "/ItCourse/DeepLearning",
    description: "Learn how advanced AI works using neural networks.",
    image1:
      "https://img.freepik.com/free-photo/3d-render-technology-background-with-code-male-head_1048-5960.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrid",
    image2:
      "https://img.freepik.com/free-photo/person-working-html-computer_23-2150038859.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrid",
  },
  {
    id: 8,
    name: " App Development",
    alt:"App Development with Brain Box Study",
    link: "/ItCourse/MobileApplication",
    description: "Learn to create apps for phones and tablets that people love to use.",
    image1:
      "https://img.freepik.com/free-photo/smartphone-with-user-interface-concept_52683-104212.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrid",
    image2:
      "https://img.freepik.com/free-photo/representations-user-experience-interface-design_23-2150104494.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrid",
  },
  {
    id: 9,
    name: "Graphic Designing",
    alt:"Graphic Designing with Brain Box Study",
    link: "/ItCourse/Graphic",
    description: "Learn tools and skills to create stunning images and graphics.",
    image1:
      "https://img.freepik.com/free-photo/woman-with-editor-occupation-wearing-headphones_482257-10564.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrid",
    image2:
      "https://img.freepik.com/free-photo/logo-designer-working-computer-desktop_23-2149142153.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrids",
  },
  {
    id: 10,
    name: "AI",
    alt:"Learn AI with Brain Box Study",

    link: "/ItCourse/ArtificialIntelligence",
    description: "Learn how AI works and how to create smart systems for the future.",
    image1:
      "https://img.freepik.com/free-photo/man-hanging-out-with-robot_23-2151112226.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrid",
    image2:
      "https://img.freepik.com/free-photo/businessman-working-futuristic-office_23-2151003701.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrid",
  },
  {
    id: 11,
    name: "Python",
    alt:"Learn Python with Brain Box Study",
    link: "/ItCourse/Python",
    description: "Learn Python, a simple and popular language for web, data, and AI projects.",
    image1:
      "https://img.freepik.com/free-photo/programming-background-with-person-working-with-codes-computer_23-2150010130.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrid",
    image2:
      "https://www.shutterstock.com/image-photo/python-programming-language-programing-workflow-260nw-1846209262.jpg",
  },
  {
    id: 11,
    name: "Ethical Hacker Certification",
    alt:"Ethical Hacker Certification with Brain Box Study",
    link: "/ItCourse/EthicalHacker",
    description: "Learn how to find and fix security issues to keep systems safe.",
    image1:
      "https://img.freepik.com/free-photo/portrait-hacker-with-mask_23-2148165905.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrid",
    image2:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRPBKTFZUhmc_rYHNoB4p0ExmssQU8CpRCXFA&s",
  },
];

const CourseCard = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredProducts = products.filter((product) =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <div className="bg-white">
        <div className="max-w-7xl mx-auto lg:px-8 px-4">
          <div className="mt-10 mb-7 flex md:justify-between md:items-end md:flex-row flex-col justify-start items-start">
            <div>
              <h2 className="font-bold dark:text-white lg:text-4xl text-3xl lg:leading-9 md:leading-7 leading-9 text-amber-800">
                Our <span className="text-blue-600">Course</span>
              </h2>
              <p className="font-normal text-[15px] leading-6 text-gray-800 lg:w-8/12 md:w-9/12">
                Here are few of the most frequently asked questions by our
                valuable customers
              </p>
            </div>

            <div className="border-b-2 border-gray-500 pb-2 flex justify-center items-center md:mt-0 mt-10 md:w-auto w-full">
              <input
                placeholder="Search"
                type="text"
                aria-label="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="  lg:w-96 md:w-72 w-full focus:outline-none placeholder-gray-900 text-base font-normal text-gray-800 leading-4"
              />
              <img
                className="cursor-pointer dark:hidden"
                src="https://tuk-cdn.s3.amazonaws.com/can-uploader/ecom-faq-1-svg1.svg"
                alt="search icon"
              />
              <img
                className="cursor-pointer hidden dark:block"
                src="https://tuk-cdn.s3.amazonaws.com/can-uploader/ecom-faq-1-svg1dark.svg"
                alt="search icon dark mode"
              />
            </div>
          </div>
          <Swiper
             spaceBetween={10}
             slidesPerView={1}
             loop={true}
             grabCursor={true}
             autoplay={{ delay: 3000, disableOnInteraction: false }}
             breakpoints={{
               550: { slidesPerView: 1 },   
               768: { slidesPerView:2},   
               1024: { slidesPerView: 4 }, 
             }}
                 modules={[Autoplay, Navigation]}
             className="swiper w-full"
           >
          {filteredProducts.length === 0 ? (
            <div className="text-center text-gray-500">No products found.</div>
          ) : (
            <div className="grid bg-white lg:grid-cols-4 sm:grid-cols-2 grid-cols-1 ">
              {filteredProducts.map((product) => (
                 <SwiperSlide 
                  key={product.id}
                  className="group border-gray-300 flex w-full  flex-col self-center overflow-hidden rounded-lg border bg-gray-100 shadow-md h-full"
                >
                  <Link
                    to={product?.link}
                    className="relative mx-3 mt-3 flex h-60 overflow-hidden rounded-xl"
                    href="#"
                  >
                    <img
                      className="peer absolute top-0 right-0 h-full w-full object-cover"
                      src={product.image1}
                      alt={`${product.name} `}
                      loading="lazy"
                    />
                    <img
                      className="peer peer-hover:right-0 absolute top-0 -right-96 h-full w-full object-cover transition-all delay-100 duration-1000 hover:right-0"
                      src={product.image2}
                      alt={`${product.name} With Brain box Study`}
                      loading="lazy"
                    />
                    <svg
                      className="group-hover:animate-ping group-hover:opacity-30 peer-hover:opacity-0 pointer-events-none absolute inset-x-0 bottom-5 mx-auto text-3xl text-white transition-opacity"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                      role="img"
                      width="1em"
                      height="1em"
                      preserveAspectRatio="xMidYMid meet"
                      viewBox="0 0 32 32"
                    >
                      <path
                        fill="currentColor"
                        d="M2 10a4 4 0 0 1 4-4h20a4 4 0 0 1 4 4v10a4 4 0 0 1-2.328 3.635a2.996 2.996 0 0 0-.55-.756l-8-8A3 3 0 0 0 14 17v7H6a4 4 0 0 1-4-4V10Zm14 19a1 1 0 0 0 1.8.6l2.7-3.6H25a1 1 0 0 0 .707-1.707l-8-8A1 1 0 0 0 16 17v12Z"
                      />
                    </svg>
                  </Link>
                  <div className="mt-4 px-5 pb-5">
                    <a href="#">
                      <h5 className="text-base font-semibold text-gray-900 capitalize">
                        {product.name}
                      </h5>
                    </a>
                    <div className="mb-5 flex items-center justify-between">
                      <p>
                        <span className="text-sm text-gray-900">
                          {product.description}
                        </span>
                      </p>
                    </div>
                    {/* <Link to={product?.link} 
                      className="hover:border-white/40 flex items-center justify-center rounded-md border border-transparent bg-gray-800 hover:bg-gray-900 px-5 py-2 text-center text-base font-medium text-white focus:outline-none focus:ring-4 focus:ring-blue-300"
                    >
                      Read More
                    </Link> */}
                    <Link to={product?.link} 
                      className=" flex items-center  justify-center rounded-md border border-transparent bg-amber-700 hover:bg-amber-800 px-5 py-2 text-center text-base font-medium text-white focus:outline-none focus:ring-4 focus:ring-blue-300"
                    >
                     
                      <span className="text-sm"> Read More</span>
                      <HiArrowRight className="transform -translate-x-4 opacity-0 pl-1 text-xl transition duration-300 group-hover:opacity-100 group-hover:translate-x-0" />
                    </Link>
                  </div>
                  </SwiperSlide>
                
              ))}
            </div>
          )}
          </Swiper>
        </div>
      </div>
    </>
  );
};

export default CourseCard;
